module.exports = __webpack_public_path__ + "static/media/bg-car@2x.bda83bba.png";